import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
import { TodosWidgetHeaderProps } from "models/propTypes/todoPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { ActionLinkButton, Icon, ToggleButtonGroup } from "components/common";
import { useLocation, useNavigate } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const TodosWidgetHeader: React.FC<TodosWidgetHeaderProps> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { todoCount, initialSelection } = props;

  const goToAllTodos = () => {
    navigate(UrlHelper.formatPath("/Reports/AllToDos"), {
      state: { background: location },
    });
  };

  return todoCount !== undefined ? (
    <Grid container className={cssExports.todosWidgetHeader}>
      <Grid item container xs className={cssExports.title} direction={"row"}>
        <ActionLinkButton
          endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} displayType={StyleEnums.DisplayType.Info} />}
          onClick={goToAllTodos}
          className={cssExports.animatedLink}
        >
          <Grid item>{`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Todo)}: `}</Grid>
          <Grid item className={cssExports.todoCount}>
            {todoCount}
          </Grid>
        </ActionLinkButton>
      </Grid>
      <Grid item>
        <ToggleButtonGroup
          buttons={[
            {
              buttonKey: WintSuperkollAPIModel.TodoGroupType.Type,
              children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Type),
              onClick: props.groupTypeChangeHandler.bind(null, WintSuperkollAPIModel.TodoGroupType.Type),
            },
            {
              buttonKey: WintSuperkollAPIModel.TodoGroupType.Urgency,
              children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Urgency2),
              onClick: props.groupTypeChangeHandler.bind(null, WintSuperkollAPIModel.TodoGroupType.Urgency),
            },
          ]}
          initialSelectionKey={initialSelection}
          colorVariation="dark"
        />
      </Grid>
    </Grid>
  ) : (
    <></>
  );
};

export default TodosWidgetHeader;
